import { render, staticRenderFns } from "./WorkShifts.vue?vue&type=template&id=586ad76a&scoped=true"
import script from "./WorkShifts.vue?vue&type=script&lang=js"
export * from "./WorkShifts.vue?vue&type=script&lang=js"
import style0 from "./WorkShifts.vue?vue&type=style&index=0&id=586ad76a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586ad76a",
  null
  
)

export default component.exports